// Recovered compiled webpack factory 3055. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { Om: () => c, e2: () => s });
  var n = r(2257),
    a = r(89135),
    o = r(76871),
    i = r(51290);
  function s(e, t) {
    var r, n, o, s;
    let { fingerprint: l, span: u, breadcrumbs: c, sdkProcessingMetadata: f } = t;
    ((function (e, t) {
      let { extra: r, tags: n, user: a, contexts: o, level: i, transactionName: s } = t;
      (Object.keys(r).length && (e.extra = { ...r, ...e.extra }),
        Object.keys(n).length && (e.tags = { ...n, ...e.tags }),
        Object.keys(a).length && (e.user = { ...a, ...e.user }),
        Object.keys(o).length && (e.contexts = { ...o, ...e.contexts }),
        i && (e.level = i),
        s && "transaction" !== e.type && (e.transaction = s));
    })(e, t),
      u &&
        (function (e, t) {
          ((e.contexts = { trace: (0, i.kX)(t), ...e.contexts }),
            (e.sdkProcessingMetadata = {
              dynamicSamplingContext: (0, a.k1)(t),
              ...e.sdkProcessingMetadata,
            }));
          let r = (0, i.zU)(t),
            n = (0, i.et)(r).description;
          n && !e.transaction && "transaction" === e.type && (e.transaction = n);
        })(e, u),
      (r = e),
      (n = l),
      (r.fingerprint = r.fingerprint
        ? Array.isArray(r.fingerprint)
          ? r.fingerprint
          : [r.fingerprint]
        : []),
      n && (r.fingerprint = r.fingerprint.concat(n)),
      r.fingerprint.length || delete r.fingerprint,
      (function (e, t) {
        let r = [...(e.breadcrumbs || []), ...t];
        e.breadcrumbs = r.length ? r : void 0;
      })(e, c),
      (o = e),
      (s = f),
      (o.sdkProcessingMetadata = { ...o.sdkProcessingMetadata, ...s }));
  }
  function l(e, t) {
    let {
      extra: r,
      tags: n,
      attributes: a,
      user: i,
      contexts: s,
      level: l,
      sdkProcessingMetadata: c,
      breadcrumbs: f,
      fingerprint: d,
      eventProcessors: p,
      attachments: h,
      propagationContext: _,
      transactionName: m,
      span: g,
    } = t;
    (u(e, "extra", r),
      u(e, "tags", n),
      u(e, "attributes", a),
      u(e, "user", i),
      u(e, "contexts", s),
      (e.sdkProcessingMetadata = (0, o.h)(e.sdkProcessingMetadata, c, 2)),
      l && (e.level = l),
      m && (e.transactionName = m),
      g && (e.span = g),
      f.length && (e.breadcrumbs = [...e.breadcrumbs, ...f]),
      d.length && (e.fingerprint = [...e.fingerprint, ...d]),
      p.length && (e.eventProcessors = [...e.eventProcessors, ...p]),
      h.length && (e.attachments = [...e.attachments, ...h]),
      (e.propagationContext = { ...e.propagationContext, ..._ }));
  }
  function u(e, t, r) {
    e[t] = (0, o.h)(e[t], r, 1);
  }
  function c(e, t) {
    let r = (0, n.m6)().getScopeData();
    return (e && l(r, e.getScopeData()), t && l(r, t.getScopeData()), r);
  }
}
